import { useCallback, useEffect, useState } from "react";
import HeroCarousel from "@/pages/home/components/HeroCarousel";
import CategoryEntries from "@/pages/home/components/CategoryEntries";
import HomeIntro from "@/pages/home/components/HomeIntro";
import SectionTitle from "@/components/base/SectionTitle";
import VideoGrid from "@/components/base/VideoGrid";
import EmptyState from "@/components/base/EmptyState";
import { useFavorites } from "@/hooks/useFavorites";
import {
  getAllVideos,
  getFeatured,
  getHot,
  getLatest,
} from "@/lib/videoQuery";
import type { VideoItem } from "@/types/video";

export default function Home() {
  const featured = getFeatured();
  const latest = getLatest(8);
  const hot = getHot(8);

  const { favorites } = useFavorites();
  const [favoriteVideos, setFavoriteVideos] = useState<VideoItem[]>([]);

  const syncFavorites = useCallback(() => {
    const all = getAllVideos();
    setFavoriteVideos(all.filter((item) => favorites.includes(item.id)));
  }, [favorites]);

  useEffect(() => {
    syncFavorites();
  }, [syncFavorites]);

  return (
    <>
      <HeroCarousel items={featured} />

      <div className="mx-auto max-w-site px-4 py-10 md:px-6 md:py-14">
        <section className="mb-12 md:mb-16">
          <SectionTitle title="分类快捷入口" subtitle="按类别快速浏览你感兴趣的内容" />
          <CategoryEntries />
        </section>

        <section className="mb-12 md:mb-16">
          <SectionTitle
            title="最新上线"
            subtitle="近期开播与上线的影视条目，按更新时间排序"
            moreTo="/category/movie"
          />
          <VideoGrid videos={latest} />
        </section>

        <section className="mb-12 md:mb-16">
          <SectionTitle
            title="热门推荐"
            subtitle="播放量与用户关注度较高的精彩内容"
            moreTo="/category/tv"
          />
          <VideoGrid videos={hot} />
        </section>

        <section className="mb-12 md:mb-16">
          <SectionTitle title="我的收藏" subtitle="收藏基于浏览器本地保存，无需登录" />
          {favoriteVideos.length > 0 ? (
            <VideoGrid videos={favoriteVideos} />
          ) : (
            <EmptyState
              icon="ri-heart-3-line"
              title="还没有收藏内容"
              description="在详情页点击「收藏」按钮，喜欢的内容就会出现在这里。"
            />
          )}
        </section>

        <HomeIntro />
      </div>
    </>
  );
}